$shm_dashboard_admin_settings $mol_view
	scope \defaults
	sub <= settings_rows /
	Defaults $mol_view
		sub /
			<= Defaults_title $mol_view
				sub / \Лимиты по умолчанию для каждого нового пользователя
			<= Default_task_limit_label $mol_labeler
				title \Лимит задач Wordstat
				Content <= Default_task_limit $mol_string
					keyboard \numeric
					hint \0 — без лимита
					value? <=> default_task_limit_draft? \
					submit? <=> default_task_limit_commit? null
					event *
						^
						blur? <=> default_task_limit_commit? null
			<= Default_hourly_limit_label $mol_labeler
				title \Лимит запросов Wordstat в час
				Content <= Default_hourly_limit $mol_string
					keyboard \numeric
					hint \0 — без лимита
					value? <=> default_hourly_limit_draft? \
					submit? <=> default_hourly_limit_commit? null
					event *
						^
						blur? <=> default_hourly_limit_commit? null
			<= Default_regular_daily_limit_label $mol_labeler
				title \Лимит задач для ежедневного сбора
				Content <= Default_regular_daily_limit $mol_string
					keyboard \numeric
					hint \0 — без лимита
					value? <=> default_regular_daily_limit_draft? \
					submit? <=> default_regular_daily_limit_commit? null
					event *
						^
						blur? <=> default_regular_daily_limit_commit? null
			<= Default_query_limit_label $mol_labeler
				title \Лимит строк запросов
				Content <= Default_query_limit $mol_string
					keyboard \numeric
					value? <=> default_query_limit_draft? \
					submit? <=> default_query_limit_commit? null
					event *
						^
						blur? <=> default_query_limit_commit? null
			<= Default_subtask_limit_label $mol_labeler
				title \Лимит подзадач в задаче
				Content <= Default_subtask_limit $mol_string
					keyboard \numeric
					value? <=> default_subtask_limit_draft? \
					submit? <=> default_subtask_limit_commit? null
					event *
						^
						blur? <=> default_subtask_limit_commit? null
	Notifications $mol_view
		sub /
			<= Notifications_title $mol_view
				sub / \Уведомления и отчеты Wordstat
			<= Notifications_enabled $mol_check_box
				title \Отправлять служебные уведомления
				checked? <=> notifications_enabled? false
			<= Telegram_notifications $mol_view
				sub /
					<= Telegram_token_label $mol_labeler
						title \Токен бота Telegram
						Content <= Telegram_token $mol_password
							value? <=> telegram_token_draft? \
							submit? <=> telegram_token_commit? null
							event *
								^
								focusout? <=> telegram_token_commit? null
					<= Telegram_chat_id_label $mol_labeler
						title \ID чата служебных уведомлений Telegram
						Content <= Telegram_chat_id $mol_string
							value? <=> telegram_chat_id_draft? \
							submit? <=> telegram_chat_id_commit? null
							event *
								^
								blur? <=> telegram_chat_id_commit? null
			<= Max_notifications $mol_view
				sub /
					<= Max_token_label $mol_labeler
						title \Токен бота MAX
						Content <= Max_token $mol_password
							value? <=> max_token_draft? \
							submit? <=> max_token_commit? null
							event *
								^
								focusout? <=> max_token_commit? null
					<= Max_chat_id_label $mol_labeler
						title \ID чата служебных уведомлений MAX
						Content <= Max_chat_id $mol_string
							value? <=> max_chat_id_draft? \
							submit? <=> max_chat_id_commit? null
							event *
								^
								blur? <=> max_chat_id_commit? null
